export default __webpack_public_path__ + "static/media/card-2.5083d06a.webp";